import { render, staticRenderFns } from "./CompanyNcrMainDetails.vue?vue&type=template&id=cea50762&scoped=true&"
import script from "./CompanyNcrMainDetails.vue?vue&type=script&lang=js&"
export * from "./CompanyNcrMainDetails.vue?vue&type=script&lang=js&"
import style0 from "./CompanyNcrMainDetails.vue?vue&type=style&index=0&id=cea50762&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cea50762",
  null
  
)

export default component.exports